import {createWorker} from '@github-ui/create-worker'
import workerUrl from './find-file.worker?worker&url'

export function createFindFileWorker() {
  return createWorker(workerUrl, {type: 'module'})
}
